// src/app/services/newsletter.service.ts
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, throwError, BehaviorSubject, catchError } from 'rxjs';
import { Router } from '@angular/router';


interface AuthResponse {
  token: string;
  user: any;
}

@Injectable({
  providedIn: 'root'
})
export class NewsletterService {
  private apiUrl = `${environment.apiUrl}/newsletter`;

  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);
  


  constructor(
      private http: HttpClient,
      private router: Router
  ) {
      if (this.isBrowser) {
      }
  }

  signUpNewsletter(email: string): Observable<object> {
      return this.http.post<object>(`${this.apiUrl}/signup`, { email })
          .pipe(
              catchError(error => {
                  console.error('Newsletter signup error:', error);
                  return throwError(() => error);
              })
          );
  }




}